export default __webpack_public_path__ + "static/media/SEIYA cam_100.4c9dd1e9.jpg";